import React from "react";
import type { GatsbyBrowser } from "gatsby";
import { RunProvider } from "./src/context/RunContext";
import "./src/styles/globals.css";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) => {
  return <RunProvider>{element}</RunProvider>;
};

export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  if (typeof window !== "undefined") {
    import("leaflet").then((L) => {
      delete (L.Icon.Default.prototype as any)._getIconUrl;
      L.Icon.Default.mergeOptions({
        iconRetinaUrl:
          "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
        iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
        shadowUrl:
          "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
      });
    });
  }
};
